import React from "react";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import {useEffect, useState} from "react";
import {Price} from "../../tools/helpers"
import {TfiInfo} from "react-icons/tfi";
import {BiChevronLeft} from "react-icons/bi";
import {Reoverlay} from "reoverlay";
import ServiceModal from "../modals/ServiceModal";
import Switch from "react-switch";
import VeneshLogo from "../../images/venesh_logo.png";
import {IoShieldCheckmarkSharp} from "react-icons/io5";

const InsuranceWidgetCard=()=>{
    return       <div className="w-full animated animatedFadeInUp fadeInUp  grid border-t mt-3 pt-3 px-1  gap-2 grid-cols-2">
        <div className="flex border-l  items-center justify-center flex-col">
            <span className="text-center text-sm ">شرکت بیمه کننده</span>
            <span className="font-bold">_</span>
        </div>
        <div className="flex    items-center justify-center flex-col">
            <span className="text-center text-sm ">تاریخ پایان بیمه نامه</span>
            <span className="font-bold">_</span>
        </div>

    </div>
}
const CarTechnicalInspectionInquiryWidgetCard=()=>{
    return       <div className="w-full animated animatedFadeInUp fadeInUp  grid border-t mt-3 pt-3 px-1  gap-2 grid-cols-2">
        <div className="flex border-l  items-center justify-center flex-col">
            <span className="text-center text-sm ">وضعیت معاینه فنی</span>
            <span className="font-bold">_</span>
        </div>
        <div className="flex    items-center justify-center flex-col">
            <span className="text-center text-sm ">تاریخ اعتبار</span>
            <span className="font-bold">_</span>
        </div>

    </div>
}
const SelectServices=({services,onSelect,processInfo,discount,handlePrev,prices,handleNext})=>{

    const [price,setPrice]=useState(null);

    useEffect(()=>{
        let count=0;
        services.forEach((item,index)=>{

            if(item.default_selected||item.isSelected){
                count=count+1;
                prices.forEach((item)=>{

                    if(item.icount===count){

                       setPrice(item)
                    }
                })
            }
        })
    },[services])
    const handleChange=(e,index)=>{
        const newServices = [...services];
        if(newServices[index].disabled){
            //service disabled
            return ;
        }
        if( !newServices[index].default_selected){
            newServices[index].isSelected = !services[index].isSelected;

            onSelect(newServices)
        }


    };
    const handleConfirm=()=>{
        localStorage.setItem('payment_detail',JSON.stringify(price))
        handleNext()
    }
    const handleShowInfoModal=(service)=>{
            Reoverlay.showModal(ServiceModal,{service})
    }

    return <div className="pb-160">

        <h1 className="text-center mt-5 font-bold text-xl">تایید اصالت خودرو</h1>
        <p className=" text-center text-sm mb-3  ">اطلاعات خودرو به صورت زیر روی آگهی شما درج خواهد شد.</p>
        <div className="p-3 mb-4     bg-white overflow-hidden rounded-lg">
            <div className="w-full flex  border-b pb-3 items-center">
                <div className="flex w-full justify-between">
                    <div className="flex justify-between items-center">
                        <img alt="venesh" className={'w-20 h-auto'} src={VeneshLogo}/>

                    </div>

                    <div className="p-2 w-full ">
                        <div className="w-full justify-between flex">
                            <h1 className="text-lg  font-bold">ونش</h1>
                            <p className="bg-green-500 bg-opacity-20 py-1 px-2 rounded-full items-center gap-2 text-sm text-black text-sm flex justify-start text-green-500 ">تایید شده</p>
                        </div>
                        <p className="text-sm mt-1 ">کارت خودرو معتبر می باشد.</p>
                    </div>

                </div>


            </div>
            <div className="w-full grid  pt-3 px-1  gap-2 grid-cols-3">
                <div className="flex border-l  items-center justify-center flex-col">
                    <span className="text-center text-sm ">نوع و مدل خودرو</span>
                    <span className="font-bold">_</span>
                </div>
                <div className="flex  border-l  items-center justify-center flex-col">
                    <span className="text-center text-sm ">رنگ خودرو</span>
                    <span className="font-bold">_</span>
                </div>
                <div className="flex    items-center justify-center flex-col">
                    <span className="text-center text-sm ">سال ساخت</span>
                    <span className="font-bold">_</span>
                </div>
            </div>
            {services.map((service)=>{
                    if(service.isSelected || service.default_selected)
                    switch (service.name){
                        case "InsuranceInquiry":{
                            return <InsuranceWidgetCard key={service.name}/>
                        }
                        case "CarTechnicalInspectionInquiry":{
                            return  <CarTechnicalInspectionInquiryWidgetCard key={service.name}/>
                        }
                        default : {
                            return  <React.Fragment key={service.name}></React.Fragment>
                        }
                    }
            })}
        </div>
        {services.map((service,index) => {
            if(service.default_selected||service.isSelected){
                if(service.name==="InsuranceInquiry"){
                    localStorage.setItem('insuranceSelected',"1")
                }
            }else {
                if(service.name==="InsuranceInquiry"){
                    localStorage.removeItem('insuranceSelected')
                }
            }
            return service.visible &&!service.disabled&& service.name!=="CarCardInquiry" && service.name!=="CarModelInquiry" &&  <div key={service.name} className="w-full bg-white p-5 mt-2 flex flex-col  rounded-lg ">
                <div onClick={(e)=>handleChange(e,index)}  className="flex w-full justify-between items-center ">
                    <h1 className="  font-bold">{service.faName}</h1>

                    {!service.disabled&& <Switch onColor="#36b570" onChange={()=>{}} dir="rtl" size={50} checkedIcon={false} uncheckedIcon={false} height={20} width={40}  checked={!!(service.default_selected||service.isSelected)} /> }
                </div>
                <div onClick={()=>{handleShowInfoModal(service)}} className="flex  justify-between pt-3  mt-3  border-t   ">
                    <span className="text-sm">توضیحات بیشتر</span>
                    <BiChevronLeft/>

                </div>
            </div>
        })
        }
        <BottomButtonWrapper grid={1}>
            <div className=" grid gap-2 grid-cols-1 items-center">
                <div className="flex   items-end pb-1 justify-between">
                    {processInfo?.payment?.payment_required===false && <>
                        <div/>
                        <strong className="text-green-500">رایگان</strong>

                    </>}
                    {processInfo?.payment?.payment_required===true && price && <>
                        <span className="text-sm">مبلغ قابل پرداخت  </span>
                        <div className="flex flex-col">
                            {discount && <>
                                {<small className="line-through text-red-500">{
                                    Price((+(price.total))/10)}
                                    تومان</small>}
                                {discount.props['CService'].post_add_on===100 && <strong className="text-green-500">رایگان</strong>}
                                {discount.props['CService'].post_add_on!==100&& <strong className="text-green-500">{Price((+price.total-(+price.total*discount.props['CService'].post_add_on/100)) / 10)}تومان</strong>}
                            </>
                            }
                            {!discount && <>
                                <strong className="text-green-500">{Price((+price.total) / 10)}تومان</strong>
                            </>}

                        </div>

                    </>}
                </div>
                <div className="grid grid-cols-2 mt-2 pt-2 border-t">
                    <Button onClick={handlePrev} type="button" rounded="rounded-lg"
                            className="w-full  text-sm flex justify-center items-center"
                            theme="link"><span>بازگشت</span></Button>
                    <Button type="button" className="text-sm" rounded="rounded-lg" onClick={handleConfirm} theme="blue">مرحله بعد</Button>
                </div>
            </div>
        </BottomButtonWrapper>
    </div>
}
export default SelectServices;